import { ref } from "vue";

import { retrieveBackendSession } from "@/backend/impl/backendSessionCache";
import type { Preset } from "@/backend/natsstubs/onboarding/models";
import { captureException } from "@/error/sentry";

export function useOnboardPresets() {
  const presets = ref<Preset[]>([]);
  const isLoadingPresets = ref(true);
  const isGenerating = ref(false);

  async function loadPresets() {
    isLoadingPresets.value = true;
    try {
      const session = retrieveBackendSession();
      if (session) {
        presets.value = await session.listOnboardingPresets();
      }
    } catch (error) {
      captureException(error, { info: { message: "Failed to load onboarding presets" } });
    } finally {
      isLoadingPresets.value = false;
    }
  }

  return { presets, isLoadingPresets, isGenerating, loadPresets };
}
